<template>
  <div>
    <el-menu
      class="new_headerMenu"
      style="margin-left: 0"
      mode="horizontal"
      @select="handleSelect"
      text-color="#414A58"
      :default-active="defaultActive"
      :popper-append-to-body="false">
      <el-submenu index="1" popper-class="menu_pop user_pop">
        <!-- 优先显示nickName -->
        <template slot="title">
          <!-- <el-badge :hidden="false" :value="200" :max="99" class="el-badge-Login"> -->
          <div class="titleImg">
            <img src="../../assets/img/fi_menu.svg" alt="" />
          </div>
          <span class="titleText" style="margin-right: 10px"> {{ userData.enterprieName || userData.registerMail || '账号中心' }}</span>
          <!-- </el-badge> -->
        </template>
        <el-menu-item index="accountCenter">
          <div class="flexBetween">
            <div>账号信息管理</div>
          </div>
        </el-menu-item>
        <el-divider class="horizontal_line"></el-divider>
        <el-menu-item index="expertManage">专家库管理</el-menu-item>

        <el-menu-item v-if="common.isLogin() == -1" index="accountManage">
          <!-- <el-badge :hidden="false" :value="0" :max="99" class="el-badge-Login"> -->
          注册审批管理
          <!-- </el-badge> -->
        </el-menu-item>

        <el-menu-item v-if="common.isLogin() == -1" index="orgManage">用户组织管理</el-menu-item>
        <el-divider v-if="common.isLogin() == -1" class="horizontal_line"></el-divider>
        <el-menu-item index="logOut">退出登录</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '',
      MenuData: [],
      userData: {},
    };
  },
  created() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
    // 当前激活菜单的 index
    defaultActive() {
      let pathLength = this.$route.path.split('/').reverse();
      // console.log('🚀 ~ pathLength:', pathLength);
    },
  },
  mounted() {
    this.userData = this.currentUser;
  },
  watch: {
    currentUser(e) {
      this.userData = e;
    },
  },
  methods: {
    // 点击 item
    handleSelect(key, keyPath) {
      this.$emit('chang', key);
    },
  },

  components: {},
};
</script>

<style lang="less" scoped>
/deep/.el-menu {
  background-color: transparent !important;
}
// 账号中心
.accoCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .text {
    font-size: 13px;

    i {
      font-size: 14px;
    }
  }

  .qi,
  .qi i {
    color: @theme_color;
  }

  .wei,
  .wei i {
    color: @status_gray;
  }
}
.titleImg {
  display: none;
  img {
    margin-right: 15px;
  }
}

// 横线
.horizontal_line {
  background-color: rgb(220, 223, 230, 0.4) !important;
  margin: 8px auto;
  width: 95%;
  // margin: ;
}

.el-menu-header .el-menu-item,
/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  font-weight: 600;
  // box-sizing: border-box;
  padding: 0;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  max-width: 168px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 去除 hover 背景色
/deep/ .el-submenu__title,
/deep/ .el-menu-item {
  background-color: transparent !important;
}

// 去除下划线
/deep/ .el-menu--horizontal {
  border-bottom: none !important;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title,
/deep/ .el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  transition: background-color 0.3s, color 0.3s !important;
}
/deep/ .el-submenu__icon-arrow {
  font-size: 18px;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title:hover,
/deep/ .el-menu--horizontal > .el-menu-item:hover {
  border-bottom: 2px solid @theme_color !important;
}

/deep/ .el-menu-item .is-active {
  border-bottom-color: none !important;
}
// 消息标记
/deep/.el-badge__content {
  background-color: #df5151;
  border-radius: 5px;
  transform: scale(0.8);
}
</style>

<style lang="less">
.submenuPopper_login .el-menu--popup {
  min-width: 230px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px rgba(67, 104, 130, 0.1);

  .el-menu-item,
  .el-submenu__title {
    background-color: transparent !important;
    line-height: 38px;
    height: 38px;
    padding: 0 22px;
    min-width: 100px !important;
  }
}

.change_pop {
  left: 804px;

  ul {
    min-width: 135px !important;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px rgba(67, 104, 130, 0.1);
  }
}
</style>
<style lang="less">
.el-badge-Login {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-badge__content.is-fixed {
    position: relative !important;
  }
}
</style>
<!-- 移动端代码 -->
<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  .titleImg {
    display: none;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #pageContent {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
  }

  .titleText {
    display: none;
  }

  .titleImg {
    display: inline-block;
  }
}
</style>
